/**
 * @file ssoLinkClickHandler.js
 * @description Shared click handling for resolved SSO login failure links.
 */

import Toast from '../components/ui/toasts/Toast';
import { getText } from '../i18n';
import { SSO_LOGIN_FAILED_HREF } from './resolveSSOLinks';

const UNRESOLVED_SSO_LINK_PATTERN = /^https:\/\/ssoId:\d+$/;

export function showSSOLoginValidationWarning() {
    Toast.warning(getText('msg_76c8d444a0eb'), {}, getText('msg_9b6f2b8b6f9a'));
}

export function showSSOGenericError() {
    Toast.error(getText('msg_dc8187fc5995'));
}

export function handleSSOLoginFailedLinkClick(event) {
    const anchor = event.target.closest('a');

    const href = anchor?.getAttribute('href') || '';

    if (
        !anchor ||
        (href !== SSO_LOGIN_FAILED_HREF &&
            !UNRESOLVED_SSO_LINK_PATTERN.test(href))
    ) {
        return false;
    }

    event.preventDefault();
    event.stopPropagation();
    showSSOLoginValidationWarning();
    return true;
}
